import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const AuditorDocsModule = lazy(loadModule);

export default AuditorDocsModule;
